import { filter, map, orderBy } from "lodash";
import React from "react";
import CollapsibleList from "./CollapsibleList";

interface Props {
  zone: ITrappingZone;
  properties: IPropertyReducer;
  selectTrap: (trap: ITrapListItem | ICollapsibleListItem) => void;
}

const TrappingZone = ({ zone, properties, selectTrap }: Props) => {
  const trapsInZone = filter(
    properties.traps,
    (trap) => trap.trapping_zone_id === zone.id,
  );
  // Order traps by code and name.
  const orderedTrapsInZone = orderBy(
    trapsInZone,
    [
      (trap) => {
        const code = trap.code;
        const codeNumber = Number(code);
        if (!isNaN(codeNumber)) {
          // Pad numbers so they sort correctly as strings.
          // For example: 2 becomes "0000000002", 100 becomes "0000000100".
          return codeNumber.toString().padStart(10, "0");
        }
        // Prefix non-numeric strings so they sort after numbers.
        return "z" + code;
      },
      (trap) => {
        const lure = properties.lures[trap.trap_lure_id];
        const insectGroup =
          lure && lure.insects && lure.insects[trap.trap_lure_id]
            ? lure.insects[trap.trap_lure_id].insect_group
            : null;
        return insectGroup?.name;
      },
    ],
    "asc",
  );
  const items = map(orderedTrapsInZone, (trap): ITrapListItem => {
    // Find the lure id for this trap
    const lure = properties.lures[trap.trap_lure_id];
    const insectGroup =
      lure && lure.insects && lure.insects[trap.trap_lure_id]
        ? lure.insects[trap.trap_lure_id].insect_group
        : null;
    return {
      id: trap.id,
      title: `${trap.code} (${trap.name || "-"})`,
      data: { ...trap, lure },
      description: insectGroup ? insectGroup.name : null,
      location: trap.location_description,
      status: trap.status,
    };
  });
  return (
    <CollapsibleList
      key={zone.id}
      title={zone.name}
      collapse={true}
      items={items}
      onItemClick={selectTrap}
    />
  );
};

export default TrappingZone;
